import {
  AdBreak,
  Advert,
  AnalyticEventObserver,
  Session,
  SessionErrorCode,
} from '@yospace/admanagement-sdk';
import { TrackingError } from '@yospace/admanagement-sdk/types/Public/TrackingError';
import { AggregateDatadogLogger } from '@tv2-player/datadog-logger';
import { AD_BREAKBEGIN, AD_BREAKEND, AD_BEGIN, AD_END } from '../../core/events';
import { trackPluginCall } from '../../util/overseer/overseer';
import { EmitableUnifiedPlayer } from '../../types/EmitableUnifiedPlayer';

export class EventObserver extends AnalyticEventObserver {
  private player;

  constructor(player: EmitableUnifiedPlayer) {
    super();
    this.player = player;
  }

  onAdvertBreakStart(adBreak: AdBreak) {
    const emitData = {
      adverts: adBreak?.getAdverts().length,
      podDuration: adBreak?.getDuration(), // seconds
      isLar: true,
    };
    trackPluginCall('Yospace', AD_BREAKBEGIN, emitData);
    this.player.emit(AD_BREAKBEGIN, emitData);
  }

  onAdvertBreakEnd() {
    trackPluginCall('Yospace', AD_BREAKEND, { isLar: true });
    this.player.emit(AD_BREAKEND, { isLar: true });
  }

  /**
   * This is a special method that gets calls if we in the lar break sends a SCTE-35 CUE-out marker.
   * We don't really do this in the lar break, but we still need to handle it.
   * It is confirmed with Yospace that it will not call adBreakEnd after this.
   */
  onAdvertBreakEarlyReturn() {
    this.onAdvertBreakEnd();
  }

  onAdvertEnd() {
    trackPluginCall('Yospace', AD_END, { isLar: true });
    this.player.emit(AD_END, { isLar: true });
  }

  onAdvertStart(advert: Advert) {
    const emitData = {
      AdManagerVersion: '3.3.1',
      isFiller: advert.isFiller(),
      creativeId: advert.getLinearCreative()?.getCreativeIdentifier(),
      AdSystem: advert.getProperty('AdSystem')?.getValue(),
      AdTitle: advert.getProperty('AdTitle')?.getValue(),
      sequence: advert.getSequence(),
      Advertiser: advert.getProperty('Advertiser')?.getValue(),
      id: advert.getIdentifier(),
      duration: advert.getDuration(),
      isLar: true,
    };

    trackPluginCall('Yospace', AD_BEGIN, emitData);
    this.player.emit(AD_BEGIN, emitData);
  }

  onAnalyticUpdate() {
    // trackPluginCall('Yospace', 'Analytic update');
  }

  onTrackingEvent(type: string) {
    // trackPluginCall('Yospace', 'Tracking event', type);
  }

  onSessionError(errorCode: SessionErrorCode, session: Session) {
    const logger = new AggregateDatadogLogger();
    trackPluginCall('Yospace', 'SessionError', { isLar: true, errorCode });
    logger.error('Yospace session error', { errorCode });
  }

  onTrackingError(trackingError: TrackingError, session: Session) {
    const logger = new AggregateDatadogLogger();
    trackPluginCall('Yospace', 'trackingError', {
      isLar: true,
      trackingErrorErrorCode: trackingError.errorCode,
    });
    logger.error('Yospace tracking error', { trackingError });
  }
}
